// app/redux/actions/leaveBalanceActions.js

// ===================== TYPES =====================
export const SET_LEAVE_BALANCE_LOADING = "SET_LEAVE_BALANCE_LOADING";
export const CLEAR_LEAVE_BALANCE_MESSAGE = "CLEAR_LEAVE_BALANCE_MESSAGE";

// Check balance availability
export const CHECK_BALANCE_REQUEST = "CHECK_BALANCE_REQUEST";
export const CHECK_BALANCE_SUCCESS = "CHECK_BALANCE_SUCCESS";
export const CHECK_BALANCE_FAIL = "CHECK_BALANCE_FAIL";

// Get user soldes
export const GET_USER_SOLDES_REQUEST = "GET_USER_SOLDES_REQUEST";
export const GET_USER_SOLDES_SUCCESS = "GET_USER_SOLDES_SUCCESS";
export const GET_USER_SOLDES_FAIL = "GET_USER_SOLDES_FAIL";

// Get all company soldes (RH Admin)
export const GET_ALL_COMPANY_SOLDES_REQUEST = "GET_ALL_COMPANY_SOLDES_REQUEST";
export const GET_ALL_COMPANY_SOLDES_SUCCESS = "GET_ALL_COMPANY_SOLDES_SUCCESS";
export const GET_ALL_COMPANY_SOLDES_FAIL = "GET_ALL_COMPANY_SOLDES_FAIL";

export const CANCEL_LEAVE_REQUEST_REQUEST = "CANCEL_LEAVE_REQUEST_REQUEST";
export const CANCEL_LEAVE_REQUEST_SUCCESS = "CANCEL_LEAVE_REQUEST_SUCCESS";
export const CANCEL_LEAVE_REQUEST_FAIL = "CANCEL_LEAVE_REQUEST_FAIL";

// Export/Import Excel
export const EXPORT_SOLDES_EXCEL_REQUEST = "EXPORT_SOLDES_EXCEL_REQUEST";
export const EXPORT_SOLDES_EXCEL_SUCCESS = "EXPORT_SOLDES_EXCEL_SUCCESS";
export const EXPORT_SOLDES_EXCEL_FAIL = "EXPORT_SOLDES_EXCEL_FAIL";

export const IMPORT_SOLDES_EXCEL_REQUEST = "IMPORT_SOLDES_EXCEL_REQUEST";
export const IMPORT_SOLDES_EXCEL_SUCCESS = "IMPORT_SOLDES_EXCEL_SUCCESS";
export const IMPORT_SOLDES_EXCEL_FAIL = "IMPORT_SOLDES_EXCEL_FAIL";

// Update single solde
export const UPDATE_SOLDE_REQUEST = "UPDATE_SOLDE_REQUEST";
export const UPDATE_SOLDE_SUCCESS = "UPDATE_SOLDE_SUCCESS";
export const UPDATE_SOLDE_FAIL = "UPDATE_SOLDE_FAIL";
export const BULK_ADJUST_SOLDES_REQUEST = "BULK_ADJUST_SOLDES_REQUEST";
export const BULK_ADJUST_SOLDES_SUCCESS = "BULK_ADJUST_SOLDES_SUCCESS";
export const BULK_ADJUST_SOLDES_FAIL = "BULK_ADJUST_SOLDES_FAIL";
 
// Get Movements History
export const GET_ALL_MOVEMENTS_REQUEST = "GET_ALL_MOVEMENTS_REQUEST";
export const GET_ALL_MOVEMENTS_SUCCESS = "GET_ALL_MOVEMENTS_SUCCESS";
export const GET_ALL_MOVEMENTS_FAIL = "GET_ALL_MOVEMENTS_FAIL";
 
export const GET_USER_MOVEMENTS_REQUEST = "GET_USER_MOVEMENTS_REQUEST";
export const GET_USER_MOVEMENTS_SUCCESS = "GET_USER_MOVEMENTS_SUCCESS";
export const GET_USER_MOVEMENTS_FAIL = "GET_USER_MOVEMENTS_FAIL";

// ===================== HELPERS =====================
export const normalizeError = (err, fallback = "Erreur") => {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    if (err?.message) return String(err.message);
    if (err?.error) return String(err.error);
    try {
        return JSON.stringify(err);
    } catch {
        return fallback;
    }
};

export const cancelLeaveRequestRequest = (requestId) => ({
    type: CANCEL_LEAVE_REQUEST_REQUEST,
    payload: { requestId },
});

export const cancelLeaveRequestSuccess = (data) => ({
    type: CANCEL_LEAVE_REQUEST_SUCCESS,
    payload: data,
});

export const cancelLeaveRequestFail = (error) => ({
    type: CANCEL_LEAVE_REQUEST_FAIL,
    payload: error,
});
// ===================== COMMON =====================
export const setLeaveBalanceLoading = (value) => ({
    type: SET_LEAVE_BALANCE_LOADING,
    payload: !!value,
});

export const clearLeaveBalanceMessage = () => ({
    type: CLEAR_LEAVE_BALANCE_MESSAGE,
});

// ===================== CHECK BALANCE =====================
export const checkBalanceRequest = (payload) => ({
    type: CHECK_BALANCE_REQUEST,
    payload,
});

export const checkBalanceSuccess = (data) => ({
    type: CHECK_BALANCE_SUCCESS,
    payload: data,
});

export const checkBalanceFail = (error) => ({
    type: CHECK_BALANCE_FAIL,
    payload: error,
});

// ===================== GET USER SOLDES =====================
export const getUserSoldesRequest = (payload) => ({
    type: GET_USER_SOLDES_REQUEST,
    payload,
});

export const getUserSoldesSuccess = (data) => ({
    type: GET_USER_SOLDES_SUCCESS,
    payload: data,
});

export const getUserSoldesFail = (error) => ({
    type: GET_USER_SOLDES_FAIL,
    payload: error,
});

// ===================== GET ALL COMPANY SOLDES =====================
export const getAllCompanySoldesRequest = (payload) => ({
    type: GET_ALL_COMPANY_SOLDES_REQUEST,
    payload,
});

export const getAllCompanySoldesSuccess = (data) => ({
    type: GET_ALL_COMPANY_SOLDES_SUCCESS,
    payload: data,
});

export const getAllCompanySoldesFail = (error) => ({
    type: GET_ALL_COMPANY_SOLDES_FAIL,
    payload: error,
});

// ===================== EXPORT SOLDES EXCEL =====================
export const exportSoldesExcelRequest = () => ({
    type: EXPORT_SOLDES_EXCEL_REQUEST,
});
export const exportSoldesExcelSuccess = () => ({
    type: EXPORT_SOLDES_EXCEL_SUCCESS,
});
export const exportSoldesExcelFail = (error) => ({
    type: EXPORT_SOLDES_EXCEL_FAIL,
    payload: error,
});

// ===================== IMPORT SOLDES EXCEL =====================
export const importSoldesExcelRequest = (file) => ({
    type: IMPORT_SOLDES_EXCEL_REQUEST,
    payload: file,
});
export const importSoldesExcelSuccess = (data) => ({
    type: IMPORT_SOLDES_EXCEL_SUCCESS,
    payload: data,
});
export const importSoldesExcelFail = (error) => ({
    type: IMPORT_SOLDES_EXCEL_FAIL,
    payload: error,
});

// ===================== UPDATE SOLDE =====================
export const updateSoldeRequest = (id, data) => ({
    type: UPDATE_SOLDE_REQUEST,
    payload: { id, data },
});

export const updateSoldeSuccess = (data) => ({
    type: UPDATE_SOLDE_SUCCESS,
    payload: data,
});

export const updateSoldeFail = (error) => ({
    type: UPDATE_SOLDE_FAIL,
    payload: error,
});

export const bulkAdjustSoldesRequest = (data) => ({ type: BULK_ADJUST_SOLDES_REQUEST, payload: data });
export const bulkAdjustSoldesSuccess = (data) => ({ type: BULK_ADJUST_SOLDES_SUCCESS, payload: data });
export const bulkAdjustSoldesFail = (error) => ({ type: BULK_ADJUST_SOLDES_FAIL, payload: error });
 
// ===================== MOVEMENTS HISTORY =====================
export const getAllMovementsRequest = () => ({
    type: GET_ALL_MOVEMENTS_REQUEST,
});
 
export const getAllMovementsSuccess = (data) => ({
    type: GET_ALL_MOVEMENTS_SUCCESS,
    payload: data,
});
 
export const getAllMovementsFail = (error) => ({
    type: GET_ALL_MOVEMENTS_FAIL,
    payload: error,
});
 
export const getUserMovementsRequest = (userId) => ({
    type: GET_USER_MOVEMENTS_REQUEST,
    payload: { userId },
});
 
export const getUserMovementsSuccess = (data) => ({
    type: GET_USER_MOVEMENTS_SUCCESS,
    payload: data,
});
 
export const getUserMovementsFail = (error) => ({
    type: GET_USER_MOVEMENTS_FAIL,
    payload: error,
});
